module.exports = __webpack_public_path__ + "static/media/appstore.7b204a07.svg";